import * as R from 'ramda';
const isNotNil = R.complement(R.isNil);
const isNotEmpty = R.complement(R.isEmpty);
const includesOneOf = items => R.pipe(R.intersection(items), isNotEmpty);
const cleanObject = R.filter(isNotNil);
const renameKeys = R.curry((keysMap, obj) => R.reduce((acc, key) => R.assoc(keysMap[key] || key, obj[key], acc), {}, R.keys(obj)));
const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
export { cleanObject, includesOneOf, isNotEmpty, isNotNil, renameKeys, sleep };
